/*
* Customer
*
* Display, update information of SubAccount
**/
import { MUAPP } from "account/api";
import { state } from "account/state";
import { submissionSuccessHandler, getUpdatedValueHelper, updateValueHelper } from "account/utils";
import { addSubAccount, displaySubAccounts } from "account/subaccount";


/**
 * cacheCustomerData
 * Submit account information updates to MU app API
 *
 * @param {object} customer - Click event object from the form
 */
export const cacheCustomerData = customer => {
  state.user = customer;
  MUAPP.cookies.setCookie("CustomerID", customer.CustomerID, 30);
}


/**
 * updateCustomer
 * Submit account information updates to MU app API
 *
 * @param {object} event - Click event object from the form
 */
export const updateCustomer = event => {
  event.preventDefault();
  const $form = $(event.target).closest("form");
  const $formWrapper = $(event.target).closest(".js-account-info");

  // PUT customer data
  const payload = {
    "Company": getUpdatedValueHelper(
      $form,
      "[name='sparsaccount[company]']",
      state.user.Company
    ),
    "Address1": getUpdatedValueHelper(
      $form,
      "[name='sparsaccount[address1]']",
      state.user.Address1
    ),
    "Address2": getUpdatedValueHelper(
      $form,
      "[name='sparsaccount[address2]']",
      state.user.Address2
    ),
    "City": getUpdatedValueHelper(
      $form,
      "[name='sparsaccount[city]']",
      state.user.City
    ),
    "State": getUpdatedValueHelper(
      $form,
      "[name='sparsaccount[province]']",
      state.user.State
    ),
    "Zip": getUpdatedValueHelper(
      $form,
      "[name='sparsaccount[zip]']",
      state.user.Zip
    ),
    "Phone": getUpdatedValueHelper(
      $form,
      "[name='sparsaccount[phone]']",
      state.user.Phone
    ),
    "Fax": state.user.Fax,
    "Email": getUpdatedValueHelper(
      $form,
      "[name='sparsaccount[email]']",
      state.user.Email
    ),
    "Country": getUpdatedValueHelper(
      $form,
      "[name='sparsaccount[country]']",
      state.user.Country
    )
  };

  $form.parsley().validate();
  if ($form.parsley().isValid()) {
    MUAPP.customer.updateCustomer(payload).then(() => {
      customerRenderHandler();
      submissionSuccessHandler($formWrapper, "Information is successfully updated.");
    });
  }
};


/**
 * Update shopify account page with customer profile data
 * @param {object} customer spars customer data
 * @param {boolean} isAdmin customer or subaccont
 */
export const renderCustomer = (customer, isAdmin) => {
  const $sparsProfile = $(".spars-account-info");
  const $sparsAddress = $(".spars-address");
  const $subAccounts = $(".js-sub-accounts");

  if (!isAdmin) {
    // Hide Form
    $sparsProfile.find("form").addClass("hidden");
    $sparsAddress.find("form").addClass("hidden");

    // Hide button
    $sparsProfile.find(".js-accordion-trigger").addClass("hidden");
    $sparsAddress.find(".js-accordion-trigger").addClass("hidden");
  } else {
    if ($subAccounts) {
      $subAccounts.removeClass("hidden");
    }
  }

  // Update Spars Account info
  // Company Name
  const $sparsAccountName = $sparsProfile.find(".spars-account-info__name");
  updateValueHelper($sparsAccountName, customer.Company);

  // Phone
  const $sparsPhone1 = $sparsProfile.find(".spars-account-info__phone");
  const $sparsPhone2 = $sparsAddress.find(".spars-address__phone");
  updateValueHelper($sparsPhone1, customer.Phone);
  updateValueHelper($sparsPhone2, customer.Phone);

  // Email
  const $sparsEmail = $sparsProfile.find(".spars-account-info__email");
  updateValueHelper($sparsEmail, customer.Email);

  // ID
  const $sparsId = $sparsProfile.find(".spars-account-info__account-id");
  updateValueHelper($sparsId, customer.CustomerID);

  // Company Name
  const $sparsName = $sparsAddress.find(".spars-address__name");
  updateValueHelper($sparsName, customer.Company);

  // Address1
  const $sparsAddress1 = $sparsAddress.find(".spars-address__address1");
  updateValueHelper($sparsAddress1, customer.Address1);

  // Address2
  const $sparsAddress2 = $sparsAddress.find(".spars-address__address2");
  updateValueHelper($sparsAddress2, customer.Address2);

  // City
  const $sparsCity = $sparsAddress.find(".spars-address__city");
  updateValueHelper($sparsCity, customer.City);

  // Province / State
  const $sparsState = $sparsAddress.find(".spars-address__province");
  updateValueHelper($sparsState, customer.State);

  // Zip
  const $sparsZip = $sparsAddress.find(".spars-address__zip");
  updateValueHelper($sparsZip, customer.Zip);

  // Country
  const $sparsCountry = $sparsAddress.find(".spars-address__country");
  updateValueHelper($sparsCountry, customer.Country);

  // Sets accountowner class on body to show subaccount add/edit buttons
  // TODO: Remove "|| true" when BE is updated with accountOwner field
  if (isAdmin) {
    $("body").addClass("spars-user--accountowner");
  }

  $sparsProfile.removeClass("hidden");

  if (window.custom) window.custom.formLabelAnimation.init();
};


/**
 * customerRenderHandler
 * 
 * Get Customer Info from SPARS, and
 * initialize rendering for Account Main Page.
 */
export const customerRenderHandler = () => {
  MUAPP.customer.getCustomer().then(
    data => {
      if (!data.customer) return false;
      cacheCustomerData(data.customer[0]);
      renderCustomer(data.customer[0], data.is_admin);
      return MUAPP.subAccounts.getSubAccounts();
    }
  ).then(
    data => {
      displaySubAccounts(data.subAccounts);
      // $("#EditSparsAccount input[type='submit']").on("click", updateCustomer);
      // $("#EditPrimaryBusinessAddress input[type='submit']").on("click", updateCustomer);
      $("#AddSparsSubAccount input[type='submit']").on("click", addSubAccount);
    }
  );
}



// WEBPACK FOOTER //
// ./src/scripts/src/account/customer.js